var _effectorFileName = "/src/page-content/home/components/pluses-work-with-us/pluses-work-with-us.tsx";
import Link from 'next/link';
import { Article } from '@/shared/components/article';
import DownloadIcon from '@/shared/components/icons/download-icon';
import { TextPlusesList } from '@/shared/components/text-pluses-list';
import { Button } from '@/shared/components/ui/button';
import { Card } from '@/shared/components/ui/card';
import { cn } from '@/shared/lib/cn';
import { FOR_COMPANIES_PLUSES_LIST } from './constants/pluses-list';
export const PlusesWorkWithUs = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Our strengths</h2>

      <section className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1fr,minmax(200px,30%)] xl:grid-cols-[1fr,minmax(200px,40%)]">
        <TextPlusesList items={FOR_COMPANIES_PLUSES_LIST} />

        <Card className={cn('group relative mx-auto max-w-96 overflow-hidden rounded-xl px-4 py-6 md:gap-x-8',
      // light styles
      'bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]',
      // dark styles
      'transform-gpu dark:bg-black dark:[border:1px_solid_rgba(255,255,255,.1)] dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset]')}>
          <div className="flex-1 space-y-1">
            <h3 className="mb-3 header-h3 sm:mb-6">
              We&nbsp;have described everything in&nbsp;detail in&nbsp;our proposal
            </h3>

            <div className="flex justify-center lg:block">
              <Link href="/files/enlerno-business-proposal.pdf" rel="noopener noreferrer" target="_blank" download="Enlerno - business proposal" aria-label="Enlerno - business proposal">
                <Button className="space-x-2" type="button" variant="outline" aria-label="Download business proposal">
                  <span>Read / Download</span>

                  <DownloadIcon className="h-5 w-5 text-brand-accent-normal dark:text-brand-accent-light" />
                </Button>
              </Link>
            </div>
          </div>
        </Card>
      </section>
    </Article>;
};